import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

export default class CouponsService {
  static async getActiveCoupons(iso) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.get(`${adminUrl}/codes/active?iso=${iso}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return response.data;
    } catch (error) {
      return { status: 'error' };
    }
  }
}
